package one.healthium.uscreen.domain

import one.healthium.uscreen.domain.models.UScreenFlowModel

class UScreenInteractor(
    private val repository: UScreenRepository,
) {
    suspend fun get(): UScreenFlowModel = repository.get()
}
